import { render, staticRenderFns } from "./VoterSecrets.vue?vue&type=template&id=087b5efa&"
import script from "./VoterSecrets.vue?vue&type=script&lang=js&"
export * from "./VoterSecrets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports